﻿export default class FinancialData {
    constructor() {
        this.dom = {
            $: window.$
        };
        this.init();
    }
    init() {
        this.validateBnkAccount();
        this.clearBankAccountNumber();
        this.showNoBankAccount();
    }

    clearBankAccountNumber() {
        //Clear back account when user selects no bank account
        $('body').on('click', '.bank-account', function () {
            if ($(this).is(":checked")) {
                $('.bank-number').val('');
                $('.bank-account-number .input-field-description').text('');
            }
            $('.bank-number').valid();
        });
    }

    showNoBankAccount() {
        if ($('.bank-number').length > 0 && $('.bank-number').val().length > 0) $('.bank-number').trigger('blur');

        //Reset form if user clears bank number
        $('body').on('keyup', '.bank-number', (e) => {
            let $target = $(e.currentTarget);

            if ($target.val().length === 0) {
                $('.row-no-bank-account').show();
                $('.row-time-at-bank').hide();
            }
        });
    }

    validateBnkAccount() {
        var keys = { "keys": ["BANKAC_INVALID_FORMAT", "BANKAC_NOT_NULL", "BANKAC_NOT_FOUND"] };
        getAjaxData("/api/sitecore/validations/GetValidationMessages", "POST", false, keys, function (data) {
            if (data) {
                $.validator.addMethod('checkBankAccountFormat', function (value, element) {
                    let bankValid = /\d{2}\s\d{4}\s\d{4}\s\d{4}\s\d{4}\s\d{4}\s\d{4}/.test(value);
                    if (!bankValid) {
                        $('.time-at-bank').val('').trigger('change');
                        $('.row-time-at-bank').hide();
                        $('.input-field-description').hide();
                        $('.row-no-bank-account').show();
                    }
                    return $('.bank-account').is(':checked') || bankValid;
                }, data.BANKAC_INVALID_FORMAT);

                $.validator.addMethod('checkBankAccount', function (value, element) {
                    let bankNotNull = (value.length > 0);
                    if (!bankNotNull) {
                        $('.time-at-bank').val('').trigger('change');
                        $('.row-time-at-bank').hide();
                        $('.input-field-description').hide();
                        $('.row-no-bank-account').show();
                    }
                    return $('.bank-account').is(':checked') || bankNotNull
                }, data.BANKAC_NOT_NULL);

                $.validator.addMethod('checkValidBankAccount', function (value, element) {
                    var isValid = false;

                    value = value.replace(/\s/g, '');
                    $(".bank-number").closest('.input-field-wrap').find('.input-field-spinner').show();
                    $(".bank-number").closest('.input-field-wrap').find('.input-field-sufix').hide();

                    $.ajax({
                        type: 'POST',
                        async: false,
                        url: '/api/sitecore/FinancialData/VerifyBankAccountNo',
                        data: { input: value },
                        error: function () { },
                        success: function (response) {
                            $(".bank-number").closest('.input-field-wrap').find('.input-field-spinner').hide();
                            $(".bank-number").closest('.input-field-wrap').find('.input-field-sufix').show();
                            $('.bank-number-error').hide();
                            $('.input-field-description').remove();

                            var bankAccNoField = $(element);

                            var inlineHtml = "<span class='input-field-description'>" + response.GeneralMessage + "</span>";
                            bankAccNoField.after(inlineHtml);

                            if (response.ErrorMessage.length > 1) {
                                $(element).data("errMessage", response.ErrorMessage);
                                isValid = false;
                            } else {
                                let bankValid = true;
                                $('.row-time-at-bank').toggle(bankValid);
                                $('.time-at-bank').prop("disabled", false);

                                $('.row-no-bank-account').toggle(!bankValid);
                                $('.input-field-description').toggle(bankValid);
                                isValid = true;
                            }
                        }
                    });
                    return $('.bank-account').is(':checked') || isValid;

                }, function (params, element) {
                    return $(element).data("errMessage");
                });

                $.validator.addClassRules('bank-number', { checkBankAccount: FinancialData.isBankAccount, checkBankAccountFormat: FinancialData.isBankAccount, checkValidBankAccount: FinancialData.isBankAccount });
            }
        });

    }

    static isBankAccount() {
        return (!$('.bank-account').is(':checked'));
    }

}

document.addEventListener('DOMContentLoaded', () => new FinancialData());
